import { getType } from '@/Utility/TypeInfo';

let pool = {};

export function get(Type) {
    let instance = getInstance(Type);

    return function () {
        instance.constructor.apply(instance, arguments);
        return instance;
    };
}

function getInstance(Type) {
    let type = getType(Type);
    return readManagedInstance(type) || createManagedInstance(Type, type);
}

function createManagedInstance(Type, type) {
    let instance = instantiate(Type, type);
    addToPool(instance);

    return instance;
}

function readManagedInstance(type) {
    if (type in pool) {
        let poolOfType = pool[type];

        for (let i = 0; i < poolOfType.length; i++) {
            let instance = poolOfType[i];

            if (instance.isDisposed === true) {
                return instance;
            }
        }
    }
}

function instantiate(Type, type) {
    let instance = construct(Type);
    instance.type = type;

    return instance;
}

function construct(Type) {
    let EmptyFunction = () => { };
    EmptyFunction.prototype = Type.prototype;

    return new EmptyFunction();
}

function addToPool(instance) {
    if (!(instance.type in pool)) {
        pool[instance.type] = [];
    }

    pool[instance.type].push(instance);
}